module.exports = __webpack_public_path__ + "static/img/控件_复选框_s.5eec10ee.svg";